export default {
    phone: '+31 10 26 13 373',
    email: 'contact@mirzacles.tech',
    contactEndPoint: 'https://script.google.com/macros/s/AKfycbxBI69gTNB2YnJ5oMHDO5X3193Sp3CatfzTARohCAgFNg5btmI/exec',
    applyEndPoint: 'https://script.google.com/macros/s/AKfycbwJ09cZ6cz4I8FqM7E9Z8sQ1JBaQAKsEre-eJQy5-dW9RqXEWEx/exec',
    vacancies: [
      {
        name: 'MEDIOR/SENIOR LINUX ENGINEER',
        slug: 'linux-engineer',
        short: 'Linux, minimaal ervaring 3+ jaar',
        location: 'Rotterdam',
        experience: 3,
        description1: 'Ben jij een Linux Engineer in hart en nieren en ben je meer te vinden op StackOverflow/GitHub dan op social media? Werk je graag met tools als Puppet en Ansible en ben je gepassioneerd in het maken van technische ontwerpen? Dan hebben wij de perfecte job voor jou!',
        description2: 'Als Linux Engineer werk je samen in een ambitieus tech team van 7 personen (en groeiend) in hartje Rotterdam waarin onderlinge samenwerking en kwaliteit centraal staan. Je werkt aan nieuwe features voor onze high traffic platformen en bent zeker niet verlegen ingesteld. Je bent dan ook kritisch op je werk en prikkelt je teamgenoten om naar perfectie te streven.',
        requirements: [
          'Minimaal HBO werk- en denkniveau;',
          'Je hebt minimaal 3 jaar professionele werkervaring;',
          'Bezit van een RHCA-certificaat is een pré (ervaring is wat telt);',
          'Je bent sterk analytisch en hebt een probleemoplossend vermogen;',
          'Je hebt goede kennis van Linux, bij voorkeur CentOS;',
          'Goede kennis van de volgende technieken: email, web (nginx, php-fpm), databases, scripting - Bash en Python (of andere scripting talen);',
          'Database administratie – met 1 van de volgende softwarepakketten: MySQL (MariaDB), PostgreSQL, Galera, Database Replication;',
          'Load balancing (HAProxy);',
          'Puppet configuration management;',
          'Linux network troubleshooting and management;',
          'Version control systems, voorkeur Git;',
          'Je bent bereid om ook buiten kantoortijden de servers te monitoren en in geval van nood bij te springen.'
        ],
        offers: [
          'Een sfeervolle werkomgeving in hartje Rotterdam;',
          '8% vakantiegeld bovenop een royaal salaris;',
          '25 vakantiedagen om lekker van te genieten in de zon, sneeuw of regen;',
          'Reiskostenvergoeding of kilometervergoeding;',
          'Voldoende ruimte om zelfstandig te werken en jezelf te ontwikkelen;',
          'Verantwoordelijkheid en inspraak in het optimaliseren van de dienstverlening;',
          'Het bouwen en optimaliseren van high traffic websites;',
          'Mogelijkheid om 32 uur te werken;',
          'Mobiele telefoon en laptop van de zaak.'
        ]
      },
      {
        name: 'MEDIOR/SENIOR PHP LARAVEL DEVELOPER',
        slug: 'php-laravel-developer',
        short: 'PHP Laravel, minimaal ervaring 2+ jaar',
        location: 'Rotterdam',
        experience: 2,
        description1: 'Ben jij een gepassioneerde en ondernemende PHP-programmeur die ervaring heeft met het Laravel framework? En ben je op zoek naar een uitdaging bij een organisatie waarbij eigen inbreng echt wordt gewaardeerd? Een organisatie waar jij jezelf kunt ontwikkelen en zelfstandig aan high traffic websites sleutelt? Dan hebben wij de perfecte job voor jou!',
        description2: 'Als PHP-programmeur werk je samen in een ambitieus tech team van 7 personen (en groeiend) in hartje Rotterdam waarin onderlinge samenwerking en kwaliteit centraal staan. Je werkt aan nieuwe features voor onze high traffic platformen en bent zeker niet verlegen ingesteld. Je bent dan ook kritisch op je code en prikkelt je teamgenoten om naar perfectie te streven.',
        requirements: [
          'Minimaal HBO werk- en denkniveau;',
          'Minimaal 4 jaar professionele werkervaring als PHP-programmeur (PHP, MySQL, Javascript zoals jQuery, HTML5);',
          'Minimaal 2 jaar ervaring met het Laravel framework;',
          'Zorgvuldige en nette programmeerstijl (documenteren hiervan);',
          'Je kunt zowel zelfstandig als in teamverband werken;',
          'Je bezit kennis over unit- en integratietests en hebt ervaring van versiebeheer (GIT);',
          'Je hebt een goede beheersing van de Nederlandse of de Engelse taal in woord en geschrift.'
        ],
        offers: [
          'Een sfeervolle werkomgeving in hartje Rotterdam;',
          '8% vakantiegeld bovenop een royaal salaris;',
          '25 vakantiedagen om lekker van te genieten in de zon, sneeuw of regen;',
          'Reiskostenvergoeding of kilometervergoeding;',
          'Voldoende ruimte om zelfstandig te werken en jezelf te ontwikkelen;',
          'Verantwoordelijkheid en inspraak in het optimaliseren van de dienstverlening;',
          'Het bouwen en optimaliseren van high traffic websites;',
          'Mogelijkheid om 32 uur te werken;',
          'Mobiele telefoon en laptop van de zaak.'
        ]
      }
    ]
};